// extracted by mini-css-extract-plugin
export default {"input":"Form_input__FTtTw","textarea":"Form_textarea__TD5sz","label":"Form_label__8nx+5","invalid":"Form_invalid__K2pTF","recaptchaWrapper":"Form_recaptchaWrapper__OOffI"};